function encodeSpecialChar(item) {
  return item
    .replace(/&amp;/g, "&")
    .replace(/&#039;/g, "'")
}

export default encodeSpecialChar